import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import axios from 'axios';

const Edit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [toast, setToast] = useState(null);
    const [pet, setPet] = useState({
        name: "",
        type: "",
        description: "",
        skill1: "",
        skill2: "",
        skill3: ""
    });

    const showToast = (message, type = 'success') => {
        setToast({ message, type });
        setTimeout(() => setToast(null), 3000);
    };

    useEffect(() => {
        axios.get(`http://localhost:8000/api/displayOne/${id}`)
            .then(res => {
                console.log(res);
                setPet(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    }, [id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        setErrors({});

        axios.put(`http://localhost:8000/api/update/${id}`, pet)
            .then(res => {
                console.log(res);
                showToast('Pet updated successfully! 🎉', 'success');
                setTimeout(() => {
                    navigate('/');
                }, 1500);
            })
            .catch(err => {
                console.log(err.response.data.errors);
                setErrors(err.response.data.errors);
                showToast('Please fix the errors below', 'error');
                setSubmitting(false);
            });
    };

    if (loading) {
        return (
            <div className='app-container'>
                <div className="navbar navbar-light">
                    <h1>Pet Shelter</h1>
                    <Link to={'/'}>back to home</Link>
                </div>
                <div className="loading">
                    <div className="spinner"></div>
                    <p className="loading-text">Loading pet details...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='app-container fade-in'>
            {toast && (
                <div className="toast-container">
                    <div className={`toast ${toast.type}`}>
                        <span className="toast-icon">
                            {toast.type === 'success' ? '✅' : '❌'}
                        </span>
                        <span className="toast-message">{toast.message}</span>
                    </div>
                </div>
            )}

            <div className="navbar navbar-light">
                <h1>Pet Shelter</h1>
                <Link to={'/'}>back to home</Link>
            </div>

            <h3>Edit {pet.name}'s Information</h3>

            <div className="form-container scale-in">
                <form onSubmit={handleSubmit}>
                    <div className='form-grid'>
                        <div className='form-section'>
                            <div className="form-group">
                                <label className="required">Pet Name</label>
                                <input 
                                    className='form-control' 
                                    type='text' 
                                    value={pet.name}
                                    onChange={e => setPet({...pet, name: e.target.value})}
                                />
                                {errors.name && <p className='error'>{errors.name.message}</p>}
                            </div>

                            <div className="form-group">
                                <label className="required">Pet Type</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    value={pet.type}
                                    onChange={e => setPet({...pet, type: e.target.value})}
                                />
                                {errors.type && <p className='error'>{errors.type.message}</p>}
                            </div>

                            <div className="form-group">
                                <label className="required">Pet Description</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    value={pet.description}
                                    onChange={e => setPet({...pet, description: e.target.value})}
                                />
                                {errors.description && <p className='error'>{errors.description.message}</p>}
                            </div>

                            <button 
                                type="submit" 
                                className="btn btn-primary"
                                disabled={submitting}
                            >
                                {submitting ? 'Updating Pet...' : 'Update Pet'}
                            </button>
                        </div>

                        <div className='form-section'>
                            <span className="form-section-header">Skills (Optional)</span>
                            
                            <div className="form-group">
                                <label>Skill 1</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    value={pet.skill1 || ""}
                                    onChange={e => setPet({...pet, skill1: e.target.value})}
                                />
                            </div>

                            <div className="form-group">
                                <label>Skill 2</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    value={pet.skill2 || ""}
                                    onChange={e => setPet({...pet, skill2: e.target.value})}
                                />
                            </div>

                            <div className="form-group">
                                <label>Skill 3</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    value={pet.skill3 || ""}
                                    onChange={e => setPet({...pet, skill3: e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Edit;